import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UnauthenticatedRoutingModule } from './unauthenticated-routing.module';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { UnauthenticatedContainerComponent } from './components/unauthenticated-container/unauthenticated-container.component';
import { SharedModule } from '../_shared/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MaterialModule } from '../_shared/material/material.module';
import { LinkCardComponent } from './components/link-card/link-card.component';

@NgModule({
  declarations: [
    WelcomeComponent,
    LinkCardComponent,
    UnauthenticatedContainerComponent,
  ],
  imports: [
    CommonModule,
    UnauthenticatedRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    MaterialModule,
    FormsModule
  ],
  providers: []
})
export class UnauthenticatedModule {}
